<template>
  <b-container>
    <b-row>
      <b-col cols="12">
        <base-bread-crumb :items="breadcrumbs" class="bg-white" />
      </b-col>
    </b-row>

    <form-micro-credential :user="user" :fallback="fallbackRoute" />
  </b-container>
</template>

<script>
import BaseBreadCrumb from '@/components/base-components/BaseBreadCrumb';
import FormMicroCredential from './components/FormMicroCredential.vue';
import { userInfoMixin } from '@/mixins';

export default {
  components: {
    BaseBreadCrumb,
    FormMicroCredential
  },

  mixins: [userInfoMixin],

  computed: {
    breadcrumbs() {
      return [
        {
          key: 'design-planning',
          name: 'Design and planning',
          to: {
            name: 'design-planning'
          }
        },
        {
          key: 'create-credential',
          name: 'Create micro-credentials',
          active: true
        }
      ];
    },

    fallbackRoute() {
      return {
        name: 'design-planning'
      };
    }
  }
};
</script>
